/* global common */
import { getLastSearch } from '@html/_common/utils';

export default function AOHeaderPaxSelectorInput() {
  this.common = {};
  if (typeof getLastSearch !== 'undefined') {
    this.common = { getLastSearch };
  } else {
    this.common = common;
  }

  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;
  const updatePaxTravelerData = (paxData) => {
    let adults = 0;
    let children = 0;

    if (paxData.numberOfAdults) {
      adults = paxData.numberOfAdults;
    }

    if (paxData.numberOfChildren) {
      children = paxData.numberOfChildren;
    }

    $('.js-ao-header-pax-selector__main-input-who-number').text(`${adults + children}`);
  };

  const updatePaxMonthData = (month, year) => {
    if (month >= 1 && month <= 12) {
      // Get the localized month names from the data-months attribute
      const $whenElement = $('.js-ao-header-pax-selector__main-input-when');
      const monthsData = $whenElement.data('months');

      if (monthsData && monthsData[month - 1]) {
        // Array is 0-indexed, so subtract 1 from month number
        const shortMonthName = monthsData[month - 1];
        const yearSuffix = year ? `'${year.toString().slice(-2)}` : '';
        $whenElement.text(`${shortMonthName} ${yearSuffix}`);
        $whenElement.addClass('ao-header-pax-selector__main-input-when--active');
      }
    }
  };

  const listenToPaxTravelerChanges = () => {
    $(document).on('paxSelection:travelersChange', (_, paxData) => {
      // Defer DOM updates to next frame to improve INP
      requestAnimationFrame(() => {
        updatePaxTravelerData(paxData);
      });
    });
    $(document).on('paxSelection:monthChange', (_, monthData) => {
      // Defer DOM updates to next frame to improve INP
      requestAnimationFrame(() => {
        updatePaxMonthData(monthData.month, monthData.year);
      });
    });
  };

  const initiatePaxTravelersFromCookies = () => {
    const adultsCookie = document.cookie.split('; ').find((row) => row.startsWith('pax_number_of_adults='));
    const childrenCookie = document.cookie.split('; ').find((row) => row.startsWith('pax_number_of_children='));

    const numberOfAdults = adultsCookie && !Number.isNaN(adultsCookie.split('=')[1]) ? parseInt(adultsCookie.split('=')[1], 10) : null;
    const numberOfChildren = childrenCookie && !Number.isNaN(childrenCookie.split('=')[1]) ? parseInt(childrenCookie.split('=')[1], 10) : null;

    const numAdults = numberOfAdults || 2;
    const numChildren = numberOfChildren || 0;

    $('.js-ao-header-pax-selector__main-input-who-number').text(`${numAdults + numChildren}`);
  };

  const initiatePaxMonthFromCookies = () => {
    const cookie = document.cookie.split('; ').find((row) => row.startsWith('pax_month_year='));
    if (cookie) {
      const [month, year] = cookie.split('=')[1].split('-');
      const parsedYear = Number.isNaN(parseInt(year, 10)) ? null : parseInt(year, 10);
      const parsedMonth = Number.isNaN(parseInt(month, 10)) ? null : parseInt(month, 10);

      // Check if the month is a past month
      if (parsedYear === null
        || parsedMonth === null
        || parsedYear < currentYear
        || (parsedYear === currentYear && parsedMonth < currentMonth)) {
        return;
      }
      updatePaxMonthData(parsedMonth, parsedYear);
    }
  };

  const initiatePaxMonthFromPage = (whereData) => {
    const [month, year] = whereData.split('-');
    const parsedYear = Number.isNaN(parseInt(year, 10)) ? null : parseInt(year, 10);
    const parsedMonth = Number.isNaN(parseInt(month, 10)) ? null : parseInt(month, 10);

    if (parsedYear === null
      || parsedMonth === null
      || parsedYear < currentYear
      || (parsedYear === currentYear && parsedMonth < currentMonth)) {
      return;
    }
    updatePaxMonthData(parsedMonth, parsedYear);
    document.cookie = `pax_month_year=${parsedMonth}-${parsedYear}; path=/; expires=${new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toUTCString()}`;
  };

  const initiatePaxDataFromPageOrCookies = () => {
    if ($('main').data('when')) {
      initiatePaxMonthFromPage($('main').data('when'));
    } else {
      initiatePaxMonthFromCookies();
    }
    initiatePaxTravelersFromCookies();
  };

  const initiatePaxSearch = () => {
    const lastSearchData = this.common.getLastSearch();
    if (lastSearchData && lastSearchData.paxSearchValue) {
      const $whereElement = $('.js-ao-header-pax-selector__main-input-where');
      $whereElement.text(lastSearchData.paxSearchValue);
      $whereElement.addClass('ao-header-pax-selector__main-input-when--active');
    }
  };

  const initiate = () => {
    initiatePaxSearch();
    initiatePaxDataFromPageOrCookies();
    listenToPaxTravelerChanges();
  };

  return { initiate };
}
